import type { InputSize } from '#/global/component/Form/types'

export const Input = {
    getFormSize: (size: InputSize | undefined) => size ? `dek-form-width--${size}` : '',

    formatNumber: (value: string, pattern: string) => {
        const numbers = value.replaceAll(/\D/g, '')
        // if number of digits is less than pattern, console error
        if (numbers.length < pattern.replaceAll(/[^#]/g, '').length) {
            console.warn(`[Input.formatNumber]: number of digits is less than pattern: ${value}, ${pattern}`)
        }
        let index = 0
        return pattern.replaceAll('#', () => numbers[index++] || '')
    },

    formatPhone: (phone: string) => Input.formatNumber(
        phone,
        phone.replaceAll(/\D/g, '').length === 12 && phone[0] === '+'
            ? '+### ### ### ###'
            : '### ### ###',
    ),
}
